export default __webpack_public_path__ + "static/documentary4-4a394894d64ec143ea5e7a68b669e933.jpg";